import { InvestorPortfolio } from "./portfolios/InvestorPortfolio.tsx";
import { AnalystPortfolio } from "./portfolios/AnalystPortfolio.tsx";
import { AdvisorPortfolio } from "./portfolios/AdvisorPortfolio.tsx";
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

export function PortfolioHoldings({ role: propRole }) {
  const [userRole, setUserRole] = useState(propRole || null);

  useEffect(() => {
    // Get user role from localStorage or use prop role
    const storedRole = localStorage.getItem("userRole");
    
    if (propRole) {
      setUserRole(propRole);
    } else if (storedRole) {
      setUserRole(storedRole);
    }
  }, [propRole]);

  // Show loading state while determining role
  if (!userRole) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 min-h-[400px]">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <div className="text-muted-foreground">Loading portfolio...</div>
      </div>
    );
  }

  // Render role-specific portfolio view
  switch (userRole.toLowerCase()) {
    case "investor":
      return <InvestorPortfolio />;
    case "analyst":
      return <AnalystPortfolio />;
    case "advisor":
      return <AdvisorPortfolio />;
    default:
      return (
        <div className="flex items-center justify-center min-h-[400px]">
          <div className="text-muted-foreground">Invalid role</div>
        </div>
      );
  }
}
